export default {
  default: () => import("/usr/src/app/layouts/default.vue").then(m => m.default || m)
}